// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__204mE","inputDescription":"styles_inputDescription__3cxFn"};